



























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { Debounce } from "vue-debounce-decorator";
import { Parceiro, ParceirosService } from "@/services/parceiros.service";
import { cpf } from "@/shared/filters";
@Component({
  components: {
    Loading,
    Modal,
  },
  filters: {
    cpf,
  },
})
export default class SelectConsultor extends Vue {
  @Prop() value!: Parceiro;
  @Prop() soParceiro!: boolean;
  @Prop() rules!: undefined;
  @Prop() disabled!: boolean;
  loading = false;
  search = null;
  parceiros = [] as Parceiro[];
  mounted() {
    if (this.value && this.parceiros) {
      if (this.value.idConsultor && this.parceiros.length == 0) {
        this.parceiros.push(this.value);
      }
    }
  }
  @Debounce(500)
  @Watch("search")
  async onChange(val: string) {
    if (val) {
      this.loading = true;
      if (this.soParceiro) {
        this.parceiros = await ParceirosService.listarParceiros(val, null);
      } else {
        this.parceiros = await ParceirosService.listarNaoParceiros(val);
      }
      this.loading = false;
    }
  }
  get model() {
    return this.value;
  }

  set model(val) {
    this.$emit("input", val);
  }
}
